import { VStack, Button, HStack, Divider, Text, Image } from "@chakra-ui/react";
import { t } from "i18next";
import React from "react";
import Rating from "../../Core/Rating/Rating";
import { chartColors } from "../../../theme/chartColors";
import { jobRoute } from "../../../utils/route.utils";
import { FeedbackModal } from "../../../models/Consultant";
import { useNavigate } from "react-router";

interface Props {
	selectedRate: FeedbackModal;
}

const FeedbackContent = ({ selectedRate }: Props) => {
	const navigate = useNavigate();
	return (
		<VStack alignItems={"flex-start"}>
			<Text fontSize={"17px"} fontWeight={700} color={"#999999"}>
				{selectedRate.commentReceiver.name}
			</Text>
			<Button
				color={"hsl(var(--action))"}
				fontSize={"15px"}
				onClick={() => navigate(selectedRate.commentReceiver.link)}
				fontWeight={600}
				variant="link"
			>
				{t("contactMenu.gotoProfile")}
			</Button>
			<Image
				width={"120px"}
				height={"169px"}
				objectFit="cover"
				src={selectedRate.commentReceiver.profileImage}
				alt="profile-image"
				my={3}
				borderRadius={"3px"}
				boxShadow="0px 0px 1px 0px #00000080"
				border="3px solid #FFFFFF"
			/>
			<HStack width="100%" justify="space-between">
				<VStack alignItems={"start"}>
					<Text color={"#999999"} fontWeight={500} fontSize={"15px"}>
						{t("FEEDBACK_LEFT_BY")}
					</Text>
					<Button
						color={"hsl(var(--action))"}
						fontSize={"15px"}
						onClick={() => navigate(selectedRate.commenter.link)}
						fontWeight={600}
						variant="link"
					>
						{selectedRate.commenter.name}
					</Button>
				</VStack>
				<VStack>
					<Text color={"#999999"} fontWeight={500} fontSize={"15px"}>
						{t("JOB")}
					</Text>
					<Button
						color={"hsl(var(--action))"}
						fontSize={"15px"}
						onClick={() => navigate(jobRoute(selectedRate.job.id))}
						fontWeight={600}
						variant="link"
					>
						{`#${selectedRate.job.orderNumber}`}
					</Button>
				</VStack>
			</HStack>
			<Divider my={5} />
			{selectedRate.rateList.map((rate, i) => (
				<React.Fragment key={i}>
					<Text color={"#999999"} fontWeight={500} fontSize={"15px"}>
						{t(rate.title as any)}
					</Text>
					<HStack width={"100%"} justify={"space-between"}>
						<Rating
							initialValue={rate.value}
							size={20}
							readonly
							fillColor={chartColors.brand}
							disableFillHover
						/>
						<Text color={"#999999"} fontWeight={500} fontSize={"15px"}>
							{`${rate.value}/5`}
						</Text>
					</HStack>
				</React.Fragment>
			))}
			<Text color={"#999999"} fontWeight={500} fontSize={"15px"}>
				{t("COMMENT")}
			</Text>
			<Text fontWeight={400} fontSize={"15px"}>
				{selectedRate.comment ? selectedRate.comment : "-"}
			</Text>
		</VStack>
	);
};

export default FeedbackContent;
